export default __webpack_public_path__ + "static/media/city-hall-mailmarketing.3172b685.svg";